const bannerData = [
  { url: require('@/assets/study/banner/banner1.png') },
  { url: require('@/assets/study/banner/banner2.png') },
  { url: require('@/assets/study/banner/banner3.png') },
]
const footerLogo = [
  // { normalUrl: require('@/assets/imgs/study/logo/01-zfb.png'), hoverUrl: require('@/assets/imgs/study/logo/01-zfb-hover.png'), path: "http://www.jiaoyu.cn", active: false }
  { name: "剪&nbsp;映", url: "https://www.capcut.cn/" },
  { name: "必&nbsp;剪", url: "https://bcut.bilibili.cn/" },
  { name: "字&nbsp;由", url: "https://www.hellofont.cn/" },
  { name: "快剪映", url: "https://www.kuaijianji.com" },
  { name: "美图秀秀", url: "https://pc.meitu.com" },
  { name: "500px", url: "https://500px.com.cn/" },
  { name: "图&nbsp;虫", url: "https://stock.tuchong.com/?no_redirect=1" },
  { name: "<p>FlexClip</p><p>在线视频剪辑</p>", url: "https://www.flexclip.com/cn/tools/", fontSize: "17px" },
  { name: "中国纪录片网", url: "http://www.docuchina.cn/" },
  { name: "央视纪实", url: "https://jishi.cctv.com/" }
]
export default {
  bannerData,
  footerLogo
}